import { useEffect, useState } from 'react';
import { Avatar, Box, Button, Card, CardContent, Divider, Grid, LinearProgress, Pagination, TextField, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import StudentCard from 'components/student/StudentCard';
import { useNavigate } from 'react-router-dom';
import { useDebounce } from 'use-debounce';
import appUrls from '../../appUrls';
import { getInstitutesListRequest } from '../../services/institute';
import Skeleton from '@mui/material/Skeleton';
import Select from 'react-select';
import { selectStyles } from '../../libs/formik_fields/SelectField';
import { instituteSortOptions } from '../../data/institute';
import Breadcrumb from '../../components/ui/Breadcrumb';
import { Add as AddIcon } from '@mui/icons-material';
import { limitOptions } from '../../data';
import { getStudentsListRequest } from 'services/student';
import { DataGrid } from '@mui/x-data-grid';

const useStyles = makeStyles((theme) => ({
    mainHeading: {
        margin: theme.spacing(1),
        [theme.breakpoints.down('md')]: {
            textAlign: 'center'
        }
    },
    breadcrumbs: {
        display: 'flex',
        [theme.breakpoints.down('md')]: {
            justifyContent: 'center'
        }
    },
    clientCardsContainer: {
        padding: theme.spacing(3)
        // marginTop: theme.spacing(1)
    },
    progressBarContainer: {
        height: 5
        // marginTop: 10,
        // marginBottom: 10
    }
}));

// eslint-disable-next-line no-unused-vars
function InstitutesList(props) {
    const classes = useStyles();
    const navigate = useNavigate();

    const [itemsList, setItemsList] = useState([]);
    const [search, setSearch] = useState('');
    const [debouncedSearch] = useDebounce(search, 1000);
    const [isLoading, setIsLoading] = useState(true);
    const [isInitialLoading, setIsInitialLoading] = useState(true);
    const [sortOrder, setSortOrder] = useState(instituteSortOptions[0]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(10);
    const [totalGallery, setTotalGallery] = useState(0);
    const [totalPollQuestions, setTotalPollQuestions] = useState(0);
    const [totalProfileQuestions, setTotalProfileQuestions] = useState(0);
    const [limit, setLimit] = useState(limitOptions[0]);

    const [mutation, setMutation] = useState();

    const refetchList = () => {
        setMutation({});
    };

    useEffect(() => {
        async function fetchData() {
            setIsLoading(true);
            const sortValue = sortOrder.value;
            const data = await getStudentsListRequest({
                search: debouncedSearch,
                sortOrder: sortValue,
                page,
                limit: limit.value || 12
            });
            setIsLoading(false);
            setIsInitialLoading(false);
            if (data.error === false) {
                setTotalGallery(data.totalGallery);
                setTotalPollQuestions(data.totalPollQuestions);
                setTotalProfileQuestions(data.totalProfileQuestions);
                setItemsList(
                    data.results.map((x, index) => ({
                        ...x,
                        rowId: index + 1
                    }))
                );
                setPage(data.page);
                setTotalPages(data.totalPages);
            }
        }

        fetchData();
    }, [debouncedSearch, sortOrder, page, limit, mutation]);

    // const { data, error, isLoading, isFetching, isSuccess } = useClientsQuery();

    // const clientsList = useMemo(() => data?.data?.clients ?? [], [data]);

    const columns = [
        {
            field: 'rowId',
            headerName: 'Sr.No.',
            flex: 2
        },
        {
            field: 'image',
            headerName: 'Image',
            flex: 5,
            renderCell: (params) => (
                <div>
                    <Avatar
                        alt={params.row.name}
                        src={`${process.env.REACT_APP_AWS_BASE_PATH}/${params.row.image}` || 'no-image'}
                        sx={{ height: 40, width: 40 }}
                    />
                </div>
            )
        },
        {
            field: 'name',
            headerName: 'Name',
            flex: 10
        },
        {
            field: 'email',
            headerName: 'Email',
            flex: 10
        },
        {
            field: 'contactNumber',
            headerName: 'Phone',
            flex: 10,
            renderCell: (params) => <div>{params.row.contactNumber ? params.row.contactNumber : '-'}</div>
        },
        {
            field: 'profileQuestions',
            headerName: 'Profile Questions',
            flex: 10,
            renderCell: (params) => (
                <div>
                    {params.row.getTotalStudentProfileQuestionAnswer}/{totalProfileQuestions}
                </div>
            )
        },
        {
            field: 'pollQuestion',
            headerName: 'Poll Questions',
            flex: 10,
            renderCell: (params) => (
                <div>
                    {params.row.getTotalStudentPollQuestionAnswer}/{totalPollQuestions}
                </div>
            )
        },
        {
            field: 'gallery',
            headerName: 'Gallery',
            flex: 10,
            renderCell: (params) => (
                <div>
                    {params.row.getTotalStudentGalleries}/{totalGallery}
                </div>
            )
        },
        {
            field: 'testimonials',
            headerName: 'Testimonials',
            flex: 10,
            renderCell: (params) => (
                <div>
                    {/* <Typography title={getTotalStudentGalleries} variant="h6" component="h6" textOverflow="ellipsis" noWrap> */}
                    <Typography variant="caption">Sent </Typography> {params.row.getTotalStudentSentTestimonials} |{' '}
                    <Typography variant="caption">Received </Typography> {params.row.getTotalStudentReceiveTestimonials}
                    {/* </Typography> */}
                </div>
            )
        }
    ];

    return (
        <>
            <Breadcrumb title="Student List" />
            <Grid container justifyContent="center">
                <Grid item xs={12}>
                    {/* <Grid item xs={12}> */}
                    {/*    <Box m={2} justifyContent="center"> */}
                    {/*        <Breadcrumbs aria-label="breadcrumb" className={classes.breadcrumbs}> */}
                    {/*            <Link color="inherit" href="/"> */}
                    {/*                Home */}
                    {/*            </Link> */}
                    {/*            <Link color="inherit" href="/"> */}
                    {/*                Institutes */}
                    {/*            </Link> */}
                    {/*            <Link color="textPrimary" href="/" aria-current="page"> */}
                    {/*                List */}
                    {/*            </Link> */}
                    {/*        </Breadcrumbs> */}
                    {/*    </Box> */}
                    {/* </Grid> */}

                    <Card>
                        <CardContent
                            sx={{
                                p: 0
                            }}
                        >
                            <Grid container>
                                <Grid item xs={12}>
                                    <Grid container justifyContent="space-between">
                                        <Grid item xs={12} sm={7} md={6} lg={4} xl={3}>
                                            <Grid container>
                                                <Grid item xs={12} sm={6}>
                                                    <Box
                                                        sx={{
                                                            py: 3,
                                                            pl: 3,
                                                            pr: {
                                                                xs: 3,
                                                                sm: 0
                                                            }
                                                        }}
                                                    >
                                                        <TextField
                                                            id="search"
                                                            label="Search"
                                                            type="search"
                                                            variant="outlined"
                                                            size="small"
                                                            value={search}
                                                            onChange={(e) => setSearch(e.target.value)}
                                                            fullWidth
                                                        />
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <Box
                                                        width="100%"
                                                        sx={{
                                                            py: {
                                                                sm: 3
                                                            },
                                                            px: 3,
                                                            borderRadius: 10,
                                                            background: 'white'
                                                        }}
                                                    >
                                                        <Select
                                                            styles={selectStyles}
                                                            placeholder="Sort by"
                                                            value={sortOrder}
                                                            options={instituteSortOptions}
                                                            onChange={(e) => setSortOrder(e)}
                                                            label="Sort by"
                                                        />
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                            {/* <Box */}
                                            {/*    sx={{ */}
                                            {/*        display: 'flex', */}
                                            {/*        alignItems: 'center', */}
                                            {/*        p: 3, */}
                                            {/*        pb:{ */}
                                            {/*            xs:0, */}
                                            {/*            md:3 */}
                                            {/*        }, */}
                                            {/*    }} */}
                                            {/* > */}
                                            {/*   */}
                                            {/*    */}
                                            {/* </Box> */}
                                        </Grid>
                                        <Grid item xs={12} sm={5} md={6}>
                                            <Box
                                                p={3}
                                                display="flex"
                                                justifyContent="flex-end"
                                                sx={{
                                                    justifyContent: {
                                                        xs: 'center',
                                                        md: 'flex-end'
                                                    }
                                                }}
                                            >
                                                {/* <Button
                                                    className={classes.button}
                                                    variant="outlined"
                                                    color="primary"
                                                    sx={{
                                                        mr: 1
                                                    }}
                                                    onClick={() => navigate(appUrls.INSTITUTE_ADD)}
                                                    disableElevation
                                                    startIcon={<AddIcon />}
                                                >
                                                    Add Institute
                                                </Button> */}
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    {/* <Box */}
                                    {/*    width="100%" */}
                                    {/*    sx={{ */}
                                    {/*        display: 'flex', */}
                                    {/*        justifyContent: 'space-between', */}
                                    {/*        alignItems: 'center', */}
                                    {/*        p: 3 */}
                                    {/*    }} */}
                                    {/* > */}
                                    {/*    */}
                                    {/*   */}
                                    {/* </Box> */}
                                    {/* <Divider /> */}
                                </Grid>

                                <Grid item xs={12}>
                                    <Box className={classes.progressBarContainer}>{isLoading && <LinearProgress />}</Box>

                                    <Box px={3}>
                                        <DataGrid
                                            rows={itemsList}
                                            columns={columns}
                                            getRowId={(row) => row._id}
                                            autoHeight
                                            disableColumnMenu
                                            paginationMode="server"
                                            hideFooterPagination
                                            hideFooter
                                            isRowSelectable={false}
                                        />
                                    </Box>

                                    {/* <Grid className={classes.clientCardsContainer} container spacing={3}>
                                        {itemsList.map((student) => (
                                            <Grid key={student._id} item xs={12} md={6} lg={4} xl={3}>
                                                <StudentCard
                                                    totalGallery={totalGallery}
                                                    totalPollQuestions={totalPollQuestions}
                                                    totalProfileQuestions={totalProfileQuestions}
                                                    key={student._id}
                                                    {...student}
                                                    refetchList={refetchList}
                                                />
                                            </Grid>
                                        ))}
                                        {isInitialLoading &&
                                            [...Array(12)].map((_, i) => (
                                                <Grid key={i} item xs={12} md={6} lg={4} xl={3}>
                                                    <Skeleton variant="rect" height={300} />
                                                </Grid>
                                            ))}
                                        {!isInitialLoading && !isLoading && itemsList.length === 0 ? (
                                            <Grid item xs={12}>
                                                <Box width="100%" p={5} bgcolor="white" borderRadius={3}>
                                                    <Typography variant="h3" align="center">
                                                        No Student found
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        ) : null}
                                    </Grid> */}
                                </Grid>

                                <Grid item xs={12} mt={3}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={8} lg={10}>
                                            <Box
                                                sx={{
                                                    px: 2,
                                                    py: {
                                                        xs: 1,
                                                        md: 0
                                                    },
                                                    display: 'flex',
                                                    justifyContent: {
                                                        xs: 'center',
                                                        md: 'flex-start'
                                                    }
                                                }}
                                            >
                                                {totalPages > 0 ? (
                                                    <Pagination
                                                        color="primary"
                                                        count={totalPages}
                                                        page={page}
                                                        onChange={(event, page) => {
                                                            setPage(page);
                                                        }}
                                                    />
                                                ) : null}
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} md={4} lg={2} justifyContent="center">
                                            <Box
                                                width="100%"
                                                sx={{
                                                    px: 3,
                                                    py: {
                                                        xs: 1,
                                                        md: 0
                                                    }
                                                }}
                                            >
                                                <Select
                                                    styles={selectStyles}
                                                    placeholder="Items Per Page"
                                                    value={limit}
                                                    options={limitOptions}
                                                    onChange={(e) => setLimit(e)}
                                                    label="Items Per Page"
                                                    menuPlacement="top"
                                                />
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </>
    );
}

export default InstitutesList;
